import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useGeneralContext } from './contexts/GeneralContext'
import { sortByProprtyInteger } from './utils/sortByProperyty'
import { Redirect, useHistory } from 'react-router-dom'
import { navDirections } from './utils/navDirections'
import { DB } from '../firebase'
import { useAuthContext } from './contexts/AuthContext'
import { subjectNames } from './utils/chapter'
import { videoColors } from './utils/videoColors'
import ZoomingAnimation from './partials/ZoomingAnimation'
import thumbnail from '../Assets/pulse_video.svg'
import BookIcon from '@material-ui/icons/Book'
import PdfPreview from './partials/PdfPreview'

function OnlineClassChapters() {
    const [parts, setParts] = useState([])
    const [active, setActive] = useState({
        open: false,
        id: ''
    })
    const [materials, setMaterials] = useState([])
    const [loading, setLoading] = useState(true)
    const [materialLoading, setMaterialLoading] = useState(true)
    const [activeTab, setActiveTab] = useState(0)
    const { chapterSelected, subSelected, setPartSelected } =
        useGeneralContext()
    const { userDetails } = useAuthContext()

    const history = useHistory()

    const onChapterSelection = (part) => {
        setPartSelected(part)
        history.push(navDirections.ONLINE_CLASS_VIDEO)
    }

    useEffect(() => {
        setLoading(true)

        !!chapterSelected &&
            DB.collection('onlineClasses')
                .where('Batch', '==', userDetails?.batch?.batchName)
                .where('Subject', '==', subjectNames[subSelected])
                .where('chapterName', '==', chapterSelected)
                .where('disabled', '==', false)
                .get()
                .then((querySnapshot) => {
                    let arr = []
                    querySnapshot.forEach((doc) => {
                        arr.push({
                            ...doc.data(),
                            id: doc.id
                        })
                    })
                    setParts(arr)
                    setLoading(false)
                })
                .catch((error) => {
                    console.log('Error getting documents: ', error)
                })
    }, [])

    useEffect(() => {
        setMaterialLoading(true)

        if (!!chapterSelected && activeTab !== 0 && materials?.length === 0) {
            DB.collection('materials')
                .where('batch', '==', userDetails?.batch?.batchName)
                .where('subject', '==', subjectNames[subSelected])
                .where('chapter', '==', chapterSelected)
                .orderBy('title', 'asc')
                .get()
                .then((querySnapshot) => {
                    let arr = []
                    querySnapshot.forEach((doc) => {
                        arr.push({
                            ...doc.data(),
                            id: doc.id
                        })
                    })
                    setMaterials(arr)
                    setMaterialLoading(false)
                })
                .catch((error) => {
                    console.log('Error getting documents: ', error)
                })

            console.log('getting again')
        } else setMaterialLoading(false)
    }, [activeTab])

    return (
        (!!chapterSelected && (
            <VideoPartsWrapper>
                <ChapterName>{chapterSelected} </ChapterName>
                <Tab>
                    <TabButton
                        active={activeTab === 0}
                        onClick={() => setActiveTab(0)}
                    >
                        Videos
                    </TabButton>
                    <TabButton
                        active={activeTab !== 0}
                        onClick={() => setActiveTab(1)}
                    >
                        Materials
                    </TabButton>
                </Tab>

                <PdfPreview active={active} setActive={setActive} />

                {activeTab === 0 && (
                    <>
                        {!!parts.length &&
                            parts
                                .sort(sortByProprtyInteger('Part'))
                                .map((part, index) => (
                                    <DetailCard
                                        key={index}
                                        bg={videoColors[index % 4].bg}
                                        onClick={() => onChapterSelection(part)}
                                    >
                                        <Thumbnail>
                                            <img
                                                src={
                                                    !!part?.thumbnail
                                                        ? part.thumbnail
                                                        : thumbnail
                                                }
                                                alt="thumbnail"
                                            />
                                        </Thumbnail>
                                        <VideoDetailsContainer>
                                            <YoutubeIcon>
                                                <img
                                                    src={
                                                        videoColors[index % 4]
                                                            .icon
                                                    }
                                                    alt="video"
                                                />
                                            </YoutubeIcon>
                                            <VideoDetails
                                                text={
                                                    videoColors[index % 4].text
                                                }
                                            >
                                                <VideoPart>
                                                    {`Part ${
                                                        part.Part < 10
                                                            ? `0${part.Part}`
                                                            : part.Part
                                                    }`}
                                                </VideoPart>
                                                <VideoChapter>
                                                    {part.title || ''}
                                                </VideoChapter>
                                            </VideoDetails>
                                        </VideoDetailsContainer>
                                    </DetailCard>
                                ))}

                        {loading && !!!parts.length && <ZoomingAnimation />}
                        {!loading && !!!parts.length && (
                            <NotAvailable>No videos Available</NotAvailable>
                        )}
                    </>
                )}

                {activeTab !== 0 && (
                    <>
                        {!!materials?.length && (
                            <MaterialSection>
                                {materials?.map((material, index) => (
                                    <MaterialItem
                                        key={index}
                                        style={{
                                            backgroundColor:
                                                videoColors[index % 4].bg,
                                            color: videoColors[index % 4].text
                                        }}
                                        onClick={() => {
                                            setActive((prev) => ({
                                                ...prev,
                                                open: true,
                                                id: material.link
                                            }))
                                        }}
                                    >
                                        <BookIcon
                                            style={{ marginRight: '10px' }}
                                        />
                                        {material?.title}
                                    </MaterialItem>
                                ))}
                            </MaterialSection>
                        )}

                        {materialLoading && !!!materials.length && (
                            <ZoomingAnimation />
                        )}
                        {!materialLoading && !!!materials.length && (
                            <NotAvailable>No materials Available</NotAvailable>
                        )}
                    </>
                )}
            </VideoPartsWrapper>
        )) || <Redirect to={navDirections.HOME} />
    )
}

const VideoPartsWrapper = styled.div`
    padding-top: 6.5rem;
    margin-bottom: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`
const ChapterName = styled.h1`
    text-align: center;
    color: #fff;
    padding: 1.2rem 10px;
    font-size: 18px;
    z-index: 1;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    background-color: #2e2e53;
`

const Tab = styled.div`
    z-index: 1;
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    background-color: #2e2e53;
    border-bottom: 1px solid #59597a;
`

const TabButton = styled.button`
    font-size: 0.9rem;
    cursor: pointer;
    outline: none;
    border: none;
    color: #fff;
    flex-grow: 1;
    font-family: 'Quicksand', sans-serif;
    font-weight: 500;
    padding: 10px;
    transition: all ease-in-out 0.25s;
    background: ${({ active }) => (active ? '#393964' : 'transparent')};
`

const MaterialSection = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    flex-direction: column;
    padding-top: 1rem;
`
const MaterialItem = styled.button`
    outline: none;
    border: none;
    width: 100%;
    text-align: left;
    margin: 8px 0;
    padding: 15px;
    max-width: 450px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    font-family: 'Quicksand', sans-serif;
    font-weight: 500;
    font-size: 0.9rem;
`

const DetailCard = styled.div`
    border-radius: 20px;
    margin: 1.5rem auto;
    padding: 15px;
    background-color: ${({ bg }) => bg};
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 450px;
    cursor: pointer;
    transition: transform ease-in-out 0.2s;

    &:hover {
        transform: scale(1.02);
    }
    &:active {
        transform: scale(0.98);
    }
`
const VideoDetailsContainer = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    flex-grow: 1;
    margin-left: 1rem;
`
const YoutubeIcon = styled.div`
    width: 50px;

    img {
        width: 100%;
    }
`

const Thumbnail = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        width: 192px;
        height: 120px;
        border-radius: 15px;
        object-fit: cover;
    }
`

const VideoDetails = styled.div`
    color: ${({ text }) => text};
    display: flex;
    flex-direction: column;
`

const VideoPart = styled.p`
    font-weight: 700;
    font-size: 18px;
`
const VideoChapter = styled.p`
    font-weight: 500;
    margin: 2px 0;
    font-size: 14px;
`

const NotAvailable = styled.p`
    text-align: center;
    color: #fff;
    margin: 30px 0;
`

export default OnlineClassChapters
